import { IconPropsType } from '..';

export const ExpenseIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.4263 13.5698C15.4263 13.8854 15.301 14.1881 15.0778 14.4112C14.8546 14.6344 14.552 14.7598 14.2364 14.7598L7.09659 14.7598C6.78099 14.7598 6.47832 14.6344 6.25516 14.4112C6.032 14.1881 5.90663 13.8854 5.90663 13.5698L5.90663 6.43002C5.90663 6.11442 6.032 5.81175 6.25516 5.58859C6.47832 5.36543 6.78099 5.24006 7.09659 5.24006C7.41219 5.24006 7.71486 5.36543 7.93802 5.58859C8.16118 5.81175 8.28656 6.11443 8.28656 6.43002L8.28655 10.6603L13.3974 5.58515C13.5084 5.47498 13.64 5.38774 13.7846 5.32842C13.9293 5.2691 14.0842 5.23885 14.2406 5.2394C14.5564 5.24051 14.8587 5.36703 15.0812 5.5911C15.1914 5.70205 15.2787 5.83361 15.338 5.97828C15.3973 6.12294 15.4275 6.27788 15.427 6.43423C15.4259 6.75 15.2994 7.0524 15.0753 7.2749L9.93227 12.3798L14.2364 12.3798C14.552 12.3798 14.8546 12.5052 15.0778 12.7284C15.301 12.9515 15.4263 13.2542 15.4263 13.5698Z"
      fill="#195A1B"
    />
  </svg>
);
